import api from './axiosApi'
import type { ProcessingJobRead } from '@/types'

export async function getProcessingJob(
  jobId: string
): Promise<ProcessingJobRead> {
  const response = await api.get<ProcessingJobRead>(
    `/admin/processing/${jobId}`
  )
  return response.data
}
